import React from "react";
import { IAllocationDimension } from "helpers/allocation-dimension";
import { FiltersContainer } from "./current/filters-container";
import { IFilters } from "./types";

interface IProps {
    onFiltersChange: (filters: IFilters) => void;
    allocationDimensions: IAllocationDimension[];
    appliedFilters: IFilters;
    isServerRollup: boolean;
    collectionId?: string;
}
export const ProductCollectionToolbarFilters: React.FunctionComponent<IProps> = ({
    onFiltersChange,
    allocationDimensions,
    appliedFilters,
    isServerRollup,
    collectionId,
}) => {
    return (
        <FiltersContainer
            allocationDimensions={allocationDimensions}
            onFiltersChange={onFiltersChange}
            appliedFilters={appliedFilters}
            isServerRollup={isServerRollup}
            collectionId={collectionId}
        />
    );
};
